import React from "react";

import ScoreCardModule from "./Modals/ScoreCard/ScoreCardModule";
import { Helmet } from "react-helmet";

function Scorecard() {
  return (
    <div
      className="scorecard"
      style={{ paddingBottom: 200, backgroundColor: "#f7c9e5" }}
    >
      <Helmet>
        <title>Scorecard - roostgame.com</title>
        <meta
          name="description"
          content="The home of all Roost related updates"
        />
      </Helmet>
      <div className="container">
        <div style={{ width: "100%", padding: 5, paddingTop: 20 }}>
          <ScoreCardModule></ScoreCardModule>
        </div>
        <p style={{ padding: 5, fontStyle: "italic" }}>
          Select a player by clicking on their name, then utilize the score
          buttons on the side to modify their points
        </p>
      </div>
    </div>
  );
}

export default Scorecard;
